import { render, staticRenderFns } from "./applicationDetails.vue?vue&type=template&id=528bb942&scoped=true&"
import script from "./applicationDetails.vue?vue&type=script&lang=js&"
export * from "./applicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./applicationDetails.vue?vue&type=style&index=0&id=528bb942&prod&vars=%7B%20'sidebar-width'%20%7D&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528bb942",
  null
  
)

export default component.exports